import React, { useState, useRef } from "react";
import "./codeInput.css";

const CodeInput = ({ setInputValue }) => {
  const [code, setCode] = useState(["", "", "", ""]);
  const boxes = useRef([]);

  const handleChange = (index, value, e) => {
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value && index < 3) {
      boxes.current[index + 1].focus();
    }

    setInputValue(newCode.join(""));
  };

  const handleKeyDown = (index, e) => {
    if (e.keyCode === 8 && !code[index] && index > 0) {
      boxes.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const pastedDigits = pastedData.match(/\d/g);

    const newCode = ["", "", "", ""];

    if (pastedDigits) {
      pastedDigits.map((value, index) => {
        newCode[index] = value;
      });
    }

    setCode(newCode);
    setInputValue(newCode.join(""));
  };

  return (
    <div className="phone-verification-code-div">
      <div className="phone-verification-code-helper-div">
        {code.map((value, index) => (
          <input
            className="phone-verification-code-input"
            key={index}
            type="text"
            maxLength={1}
            value={value}
            onChange={(e) =>
              handleChange(index, e.target.value.replace(/\D/, ""), e)
            }
            onKeyDown={(e) => handleKeyDown(index, e)}
            ref={(el) => (boxes.current[index] = el)}
            autoFocus={index === 0}
            onPaste={handlePaste}
          />
        ))}
      </div>
    </div>
  );
};

export default CodeInput;
